import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import IndustryPage from './pages/IndustryPage';
import Contact from './pages/Contact';
import Navbar from './components/Navbar';
import About from './pages/About';
import Pricing from './pages/Pricing';
import ThankYouEvents from './pages/ThankYouEvents';
import ThankYouPartnerships from './pages/ThankYouPartnerships';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

const industries = [
  "hospitals", "events", "corporate", "education", "fnb", 
  "hotels", "lifestyle", "malls", "tourism", "places", "nightlife", "nonprofit"
];

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/thank-you-events" element={<ThankYouEvents />} />
          <Route path="/thank-you-partnerships" element={<ThankYouPartnerships />} />
          {industries.map(industry => (
            <Route key={industry} path={`/industry/${industry}`} element={<IndustryPage />} />
          ))}
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
